import CheckPersonRange from './src/main';

/* istanbul ignore next */
CheckPersonRange.install = function(Vue) {
  Vue.component(CheckPersonRange.name, CheckPersonRange);
};

export default CheckPersonRange;
